var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.1429 0H6.85714C3.07005 0 0 3.07005 0 6.85714V41.1429C0 44.93 3.07005 48 6.85714 48H41.1429C44.93 48 48 44.93 48 41.1429V6.85714C48 3.07005 44.93 0 41.1429 0Z",
    fill: "url(#paint0_linear_1_20949)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.248 26H13.748C13.3338 26 12.998 26.3357 12.998 26.75V34.25C12.998 34.6642 13.3338 35 13.748 35H18.248C18.6622 35 18.998 34.6642 18.998 34.25V26.75C18.998 26.3357 18.6622 26 18.248 26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.248 20H28.748C28.3338 20 27.998 20.3357 27.998 20.75V34.25C27.998 34.6642 28.3338 35 28.748 35H33.248C33.6622 35 33.998 34.6642 33.998 34.25V20.75C33.998 20.3357 33.6622 20 33.248 20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.748 14H21.248C20.8338 14 20.498 14.3357 20.498 14.75V34.25C20.498 34.6642 20.8338 35 21.248 35H25.748C26.1622 35 26.498 34.6642 26.498 34.25V14.75C26.498 14.3357 26.1622 14 25.748 14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_20949",
    x1: 10.8692,
    y1: 37.1341,
    x2: 39.1834,
    y2: 8.81995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F31D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#F42334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FC6058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7866"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.406c58128c567be094026741ad0c9107.svg";
export { ForwardRef as ReactComponent };